<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/i0dI1y/tc-custom/9781466821590.jpg?1732053254435" alt="This image is the cover for the book Get Down"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Get Down
      </h1>
      <p class="bookDescription body article font2">
        <p>Asali Solomon's characters are vivid misfits—a heathen at Jesus camp, a scheming prep-school student, a middle-aged mom pining for her salsa-dancing salad days, a scheming twentysomething virgin, a college stud in love with his weight-lifting partner, a lonely girl in love with a yellow dress. The kids in <i>Get Down </i>are trapped between their own good breeding and their burning desire to join the house party of sex, romance, and bad behavior that seems to be happening on some other block, down some other more dangerous street. The adults in <i>Get Down </i>are just trying to hold it together.<br/><br/><br/>Here is a debut that will make you laugh and cringe in equal measure. Set mostly in middle-class black Philadelphia during the crack and Reagan years, the stories in <i>Get Down </i>are antic, poignant, and utterly universal—they'll bring back memories for anyone who has ever stood in the corner of a darkened school gym wondering whether to dance . . . or duck for cover. They announce a sparkling new talent, a recent graduate of the Iowa Writers' Workshop whose work has been featured in <i>Vibe</i>, <i>Essence</i>, and the anthology <i>Naked: Black Women Bare All About Their Skin, Hair, Hips, Lips, and Other Parts.<br/></i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Asali Solomon
      </h2>
      
      <p class="authorDescription body article"><P><B>Asali Solomon </B>was born and raised in West Philadelphia. She received the Rona Jaffe Award for the stories in <I>Get Down</I>. She lives in Lexington, Virginia.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e44439fc